module.exports = __webpack_public_path__ + "static/media/pdf.ede71849.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/pdf.svg
// module id = 1669
// module chunks = 17